import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
        this.setState({
            error,
            errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-naqd-light-bg dark:bg-naqd-dark-bg px-4">
                    <div className="max-w-md w-full text-center">
                        <div className="mb-8">
                            <div className="text-6xl mb-4">⚠️</div>
                            <h1 className="text-3xl font-bold mb-4 text-naqd-light-text dark:text-naqd-dark-text">
                                Oops! Something went wrong
                            </h1>
                            <p className="text-gray-600 dark:text-gray-400 mb-6">
                                We're sorry for the inconvenience. Our team has been notified and is working to fix the issue.
                            </p>
                        </div>

                        <div className="space-y-4">
                            <button
                                onClick={() => window.location.href = '/'}
                                className="btn-primary w-full"
                            >
                                Go to Homepage
                            </button>
                            <button
                                onClick={() => window.location.reload()}
                                className="btn-secondary w-full"
                            >
                                Reload Page
                            </button>
                        </div>

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <details className="mt-8 text-left bg-red-50 dark:bg-red-900/20 p-4 rounded-lg">
                                <summary className="cursor-pointer font-semibold text-red-600 dark:text-red-400 mb-2">
                                    Error Details (Development Only)
                                </summary>
                                <pre className="text-xs overflow-auto text-red-800 dark:text-red-300">
                                    {this.state.error.toString()}
                                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                                </pre>
                            </details>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
